import {createAction} from 'typesafe-actions';

export interface Market {
  market: string;
  languages: string[];
  locale: number | Record<string, number>;
}

export const setMarket = createAction('@bs/SET_MARKET')<Market>();